<script setup>
import { computed, getCurrentInstance } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
    breadcrumbItems: {
        type: Array,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const $t = proxy.$t;
const page = usePage();
</script>

<template>
    <div class="max-h-16 py-4 pr-4 pl-6 flex items-center gap-2 border-b">
        <span><i class="pi pi-home text-surface-400 !leading-none" /></span>
        <template v-for="(item, index) in breadcrumbItems" :key="item">
            <div class="flex items-center gap-2" :class="index < breadcrumbItems.length - 1 ? 'text-surface-400 font-normal' : 'text-surface-950 dark:text-surface-0 font-medium'">
                <span class="leading-none">
                    {{ item }}
                </span>
                <span><i v-if="index < breadcrumbItems.length - 1" class="pi pi-chevron-right !text-xs !leading-none" /></span>
            </div>
        </template>
    </div>
</template>
